import React from "react";
import DropdownMenu from "components/dropDownMenu/DropdownMenu";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import { unitedStatesMeet, canadaMeet } from "util/meetHelper";

import {
  updateAttributeOnDocument,
  updateAttributesOnDocument,
} from "util/pouchActions";

class Menu extends React.Component {
  setAsCurrentAttempt = () => {
    const { meet, attempt, match } = this.props;
    const platformId = get(match, ["params", "platformId"]);
    updateAttributeOnDocument(
      meet._id,
      platformId,
      "currentAttemptId",
      attempt._id
    );
  };

  clearResult = () => {
    const { meet, attempt } = this.props;
    const changes = {
      result: null,
      decisions: null,
    };
    updateAttributesOnDocument(meet._id, attempt._id, changes);
  };

  markAttemptGood = () => {
    const { meet, attempt } = this.props;
    updateAttributeOnDocument(meet._id, attempt._id, "result", "good");
  };

  markAttemptBad = () => {
    const { meet, attempt } = this.props;
    updateAttributeOnDocument(meet._id, attempt._id, "result", "bad");
  };

  toggleRecordAttempt = (type) => {
    const { meet, attempt } = this.props;
    updateAttributeOnDocument(meet._id, attempt._id, type, !get(attempt, type));
  };

  moveToEndOfRound = () => {
    const { meet, attempt } = this.props;
    updateAttributeOnDocument(meet._id, attempt._id, "endOfRound", true);
  };

  moveToNormalPosition = () => {
    const { meet, attempt } = this.props;
    updateAttributeOnDocument(meet._id, attempt._id, "endOfRound", false);
  };

  render() {
    const { attempt, isCurrentAttempt, meet } = this.props;

    if (!attempt.weight && attempt.weight !== 0 && !attempt.result) {
      return null;
    }

    const items = [];

    if (
      !isCurrentAttempt &&
      !attempt.result &&
      (attempt.weight || attempt.weight === 0)
    ) {
      items.push({
        label: "Set as current attempt",
        onClick: this.setAsCurrentAttempt,
      });
    }

    if (attempt.result) {
      items.push({
        label: "Clear result",
        onClick: this.clearResult,
      });
    }

    if (
      attempt.weight !== 0 &&
      attempt.weight &&
      (!attempt.result || attempt.result === "bad")
    ) {
      items.push({
        label: "Mark as good attempt",
        onClick: this.markAttemptGood,
      });
    }

    if (
      (attempt.weight || attempt.weight === 0) &&
      (!attempt.result || attempt.result === "good")
    ) {
      items.push({
        label: "Mark as bad attempt",
        onClick: this.markAttemptBad,
      });
    }

    if (
      (attempt.weight || attempt.weight === 0) &&
      !attempt.result &&
      !attempt.endOfRound
    ) {
      items.push({
        label: "Move to end of round",
        onClick: this.moveToEndOfRound,
      });
    }

    if (
      (attempt.weight || attempt.weight === 0) &&
      !attempt.result &&
      attempt.endOfRound
    ) {
      items.push({
        label: "Move to normal postition in round",
        onClick: this.moveToNormalPosition,
      });
    }

    items.push(undefined);

    if (unitedStatesMeet(meet)) {
      items.push({
        label: "State Record Attempt",
        onClick: () => this.toggleRecordAttempt("stateRecord"),
        checked: !!attempt.stateRecord,
      });
    }

    if (unitedStatesMeet(meet) && meet.federation !== "WRPF") {
      items.push({
        label: "American Record Attempt",
        onClick: () => this.toggleRecordAttempt("americanRecord"),
        checked: !!attempt.americanRecord,
      });
    }

    if (canadaMeet(meet) || meet.federation === "IPF") {
      items.push({
        label: "Provincial Record Attempt",
        onClick: () => this.toggleRecordAttempt("provincialRecord"),
        checked: !!attempt.provincialRecord,
      });
    }

    if (canadaMeet(meet)) {
      items.push({
        label: "Canadian Record Attempt",
        onClick: () => this.toggleRecordAttempt("canadianRecord"),
        checked: !!attempt.canadianRecord,
      });
    }

    items.push({
      label: "Regional Record Attempt",
      onClick: () => this.toggleRecordAttempt("regionalRecord"),
      checked: !!attempt.regionalRecord,
    });

    items.push({
      label: "National Record Attempt",
      onClick: () => this.toggleRecordAttempt("nationalRecord"),
      checked: !!attempt.nationalRecord,
    });

    items.push({
      label: "World Record Attempt",
      onClick: () => this.toggleRecordAttempt("worldRecord"),
      checked: !!attempt.worldRecord,
    });

    return <DropdownMenu items={items} />;
  }
}

export default withRouter(Menu);
